import {BaseWidget} from "../../widgets/BaseWidget";
import * as ts from "../../common/Translator";
import {internalGridSizeToPixels} from "../../common/GUIUtilities";
import {currentUserId} from "../../login/LoginPresenter";
import {ajaxJSON, isNullOrUndefined} from "../../common/NamaCommon";
import * as urls from "../../constants/NamaURLS";
import {toString} from "../../common/FieldTypesUtils";
import {getValue} from "../../actions/GenericValues";
import * as CustomRepLaunchType from "../../constants/CustomRepLaunchType";
import {find} from "../../common/HasIDUtil";
import {QuestionFieldsSerializer} from "../../common/CriteriaAndQuestionsURLParser";
import {ReportLauncherPresenter} from "../../routing/ReportLauncherPresenter";
import {ReportViewerPresenter} from "../../routing/ReportViewerPresenter";
import * as places from "../../routing/places";
import {mapParameters} from "../../actions/BaseDispatcher";
import {ChartsDrawer} from "../charts/ChartsDrawer";

export class EmbeddedReportAndDashboardView extends BaseWidget {
    constructor(req) {
        super(req);
        let that = this;
        /**
         * @type {namaTypes.EditScreenReport}
         */
        that.block = req.block;
        that.forDashBoard = req.forDashBoard;
        that.relatedEditPresenter = req.editPresenter;
        that.started = false;
        that.viewHeight = req.viewHeight;
        that.viewWidth = req.viewWidth;
        that.embeddedInDashBoard = req.embeddedInDashBoard;
        if (req.editPresenter && that.block.reportInfo)
            req.editPresenter.addOnChangeListener(that.block.reportInfo, () => that.setValue());
    }

    createElement(style) {
        return $(`<ul id = ${this.elementId}></ul>`);
    }

    shouldAddBlurHandler() {
        return false;
    }

    readFromServer() {
        let that = this;
        if (!that.started)
            return;
        if (that.forDashBoard) {
            that.startEmbeddedDashboard();
            return;
        }
        if (that.reportPresenter && that.embeddedInDashBoard)
            that.reportPresenter.onRefresh();
        else
            that.initReportPresenter();
    }

    initReportPresenter() {
        let that = this;
        if (that.reportPresenter)
            return;
        that.findElement().find("#content").html("");
        if (that.reportMetadata) {
            that.showReport();
        }
        else {
            ajaxJSON(urls.FetchReportMetadata, {
                    request: JSON.stringify({
                        id: that.block.reportInfo.reportId,
                        entityType: "ReportDefinition",
                        userId: currentUserId()
                    })
                }, (result) => {
                    that.reportMetadata = result.data;
                    that.showReport();
                }
            );
        }

    }

    startEmbeddedDashboard() {
        let that = this;
        let content = that.findElement().find("#content");
        content.html("");
        let chartsDrawer = new ChartsDrawer(content, "");
        chartsDrawer.fetchCharts(that.block.reportInfo.reportId);
    }

    showReport() {
        let that = this;
        let mappingInfo = that.block.reportInfo;
        let questions = createQuestionFromMapping(mappingInfo, that.relatedEditPresenter);
        /**
         *
         * @type {ReportPlace}
         */
        let place = null;
        switch (that.block.reportInfo.launchType) {
            case CustomRepLaunchType.DirectInNewPage:
            case CustomRepLaunchType.DirectInPopup:
            case CustomRepLaunchType.Print:
                place = new places.ReportViewerPlace();
                addDefaultValueQuestions(questions, that.reportMetadata.metadata);
                break;
            case CustomRepLaunchType.ParamsInNewPage:
            case CustomRepLaunchType.ParamsInPopup:
                place = new places.ReportLauncherPlace("");
                break;
        }
        place.questions = new QuestionFieldsSerializer().toURL(questions);
        place.reportId = that.block.reportInfo.reportId;
        that.goTo(place);
    }

    /**
     *
     * @param {places.ReportPlace} place
     */
    goTo(place) {
        let that = this;
        that.reportPresenter = new ReportLauncherPresenter(place);
        if (place instanceof places.ReportViewerPlace)
            that.reportPresenter = new ReportViewerPresenter(place);
        that.reportPresenter.embeddedReportView = true;
        that.reportPresenter.viewHeight = that.calcHeight();
        if(that.viewWidth)
            that.reportPresenter.viewWidth = that.viewWidth;
        that.reportPresenter.reportContainer = that.findElement().find("#content");
        that.reportPresenter.start();
    }

    calcHeight() {
        let that = this;
        if (that.viewHeight)
            return that.viewHeight;
        return internalGridSizeToPixels(that.block.size);
    }

    afterAttach() {
        let that = this;
        let panelBar = that.findElement();
        let widgetHeight = that.calcHeight();
        if (!that.embeddedInDashBoard) {
            panelBar = that.findElement().kendoPanelBar({
                select: function (e) {
                    that.started = true;
                    that.readFromServer();
                }
            }).data("kendoPanelBar");
            panelBar.append([{
                "text": ts.translateTitledId(null, that.block),
                content: `<div id="content" style="height: ${widgetHeight}px">Please wait</div>`
            }]);
        } else {
            panelBar.append(`<div id="content" style="height: ${widgetHeight}px;width:${that.viewWidth}px">Please wait</div>`);
            that.started = true;
            that.readFromServer();
        }
        that.reportPresenter = null;
    }

    setValue() {
        let that = this;
        that.reportPresenter = undefined;
        that.readFromServer();
    }
}

/**
 *
 * @param  {namaTypes.DTOAbstractParamsMapping} mappingInfo
 */

export function createQuestionFromMapping(mappingInfo, presenter) {
    let questions = [];
    if (!presenter)
        return questions;
    let parameterValues = mapParameters(undefined, -1, mappingInfo, presenter);
    let parameterFieldMap_ = parameterFieldMap(mappingInfo);
    for (let [key, value] of parameterFieldMap_) {
        let parameterValue = parameterValues[value];
        questions.push({
            id: key, value: toString(
                parameterValue.dataType, getValue(parameterValue)), objValue: getValue(parameterValue)
        });
    }
    return questions;
}

/**
 *
 * @param  {namaTypes.DTOAbstractParamsMapping} mappingInfo
 */
export function parameterFieldMap(mappingInfo) {
    let map = new Map();
    add(mappingInfo.p1, map);
    add(mappingInfo.p2, map);
    add(mappingInfo.p3, map);
    add(mappingInfo.p4, map);
    add(mappingInfo.p5, map);
    add(mappingInfo.p6, map);
    add(mappingInfo.p7, map);
    add(mappingInfo.p8, map);
    add(mappingInfo.p9, map);
    return map;
}

/**
 *
 * @param  {namaTypes.PMap} p
 */
function add(p, map) {
    if (p.field)
        map.set(p.parameter, p.field);
}

export function addDefaultValueQuestions(questions, metadata) {
    if (!metadata || !metadata.metadata)
        return;

    let defaultValues = [];

    for (let questionFieldMetadata of metadata.metadata) {
        if (questionFieldMetadata.defaultValue) {
            defaultValues.push({
                id: questionFieldMetadata.id,
                value: questionFieldMetadata.defaultValue,
                objValue: null
            });
        }
    }
    for (let dtoFilledQuestionField of defaultValues) {
        if (isNullOrUndefined(find(dtoFilledQuestionField.id, questions)))
            questions.push(dtoFilledQuestionField);
    }
}